import {Stack} from '../../layout/stack/stack';
import {Body} from '../../typography/body';

import {KEY_ITEMS} from './consts';

import styles from './matrix-heatmap.module.css';

interface Props {
    header: string;
    subheader?: string;
    keyName: string;
}

export function MatrixHeatmapHeader(props: Props) {
    return (
        <Stack spacing={24} isHorizontal={true} alignItems='center' justifyContent='space-between'>
            <Stack spacing={2}>
                <Body size='large' color='dark' isBold={true}>
                    {props.header}
                </Body>
                {props.subheader && <Body color='medium'>{props.subheader}</Body>}
            </Stack>
            <Stack spacing={8} isHorizontal={true} alignItems='center' wrap={true}>
                <Body size='small' color='medium' isBold={true}>
                    {props.keyName}
                </Body>
                {KEY_ITEMS.map((item) => (
                    <Stack key={item.id} spacing={4} isHorizontal={true} alignItems='center'>
                        <div
                            className={styles['matrix-heatmap-legend-dot']}
                            style={{backgroundColor: item.color}}
                        />
                        <Body size='small' color='medium'>
                            {item.label}
                        </Body>
                    </Stack>
                ))}
            </Stack>
        </Stack>
    );
}
